import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageCropper from "../crop_image/ImageCropper";
import "./Blog.css";

function BlogAdd() {
    const navigate = useNavigate();
    const [group, setGroup] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogGroup/readBlogGroup`);
            const data = response.data;
            setGroup(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [formValue, setFormValue] = useState({
        foto_main: null,
        foto_satu: null,
        foto_dua: null,
        foto_tiga: null,
        title: "",
        detail_foto_main: "",
        tanggal_foto_main: "",
        title_foto_satu: "",
        detail_foto_satu: "",
        tanggal_foto_satu: "",
        title_foto_dua: "",
        detail_foto_dua: "",
        tanggal_foto_dua: "",
        title_foto_tiga: "",
        detail_foto_tiga: "",
        tanggal_foto_tiga: "",
        id_blog_group: "",
    });

    const [preview, setPreview] = useState({
        foto_main: null,
        foto_satu: null,
        foto_dua: null,
        foto_tiga: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("formValue.title_foto_satu", formValue.title_foto_satu);
        console.log("formValue.id_group", formValue.id_blog_group);
        console.log("formValue.foto_main ", formValue.foto_main);
        console.log("formValue.foto_dua", formValue.foto_dua);
        console.log("formValue.foto_tiga", formValue.foto_tiga);
        console.log("formValue.tanggal_foto_satu", formValue.tanggal_foto_satu);
        if (
            !formValue.title_foto_satu ||
            !formValue.title_foto_dua ||
            !formValue.title_foto_tiga ||
            !formValue.id_blog_group ||
            !formValue.foto_main ||
            !formValue.foto_satu ||
            !formValue.foto_dua ||
            !formValue.foto_tiga
        ) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        if (formValue.foto_main) FormDataInput.append("photo_main", formValue.foto_main);
        if (formValue.foto_satu) FormDataInput.append("photo1", formValue.foto_satu);
        if (formValue.foto_dua) FormDataInput.append("photo2", formValue.foto_dua);
        if (formValue.foto_tiga) FormDataInput.append("photo3", formValue.foto_tiga);
        FormDataInput.append("title", formValue.title);
        FormDataInput.append("tanggal_foto_main", formValue.tanggal_foto_main);
        FormDataInput.append("detail_foto_main", formValue.detail_foto_main);
        FormDataInput.append("title_foto_satu", formValue.title_foto_satu);
        FormDataInput.append("tanggal_foto_satu", formValue.tanggal_foto_satu);
        FormDataInput.append("detail_foto_satu", formValue.detail_foto_satu);
        FormDataInput.append("title_foto_dua", formValue.title_foto_dua);
        FormDataInput.append("tanggal_foto_dua", formValue.tanggal_foto_dua);
        FormDataInput.append("detail_foto_dua", formValue.detail_foto_dua);
        FormDataInput.append("title_foto_tiga", formValue.title_foto_tiga);
        FormDataInput.append("tanggal_foto_tiga", formValue.tanggal_foto_tiga);
        FormDataInput.append("detail_foto_tiga", formValue.detail_foto_tiga);
        FormDataInput.append("id_blog_group", formValue.id_blog_group);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/blog/createBlog`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambah",
                icon: "success",
            });
            navigate("/blog");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambah",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Blog</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Blog</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title"
                                                        placeholder="Masukkan Title"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>ID Group</label>
                                                    <select
                                                        className="form-control"
                                                        name="id_blog_group"
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Pilih Group</option>
                                                        {group.map((group) => (
                                                            <option
                                                                key={group.id_blog_group}
                                                                value={group.id_blog_group}
                                                            >
                                                                {group.group_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Highlight</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_main"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.foto_main && (
                                                        <div className="preview-container-blog">
                                                            <img
                                                                src={preview.foto_main}
                                                                alt="Preview"
                                                                className="preview-image-blog"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Detail Highlight</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="detail_foto_main"
                                                        placeholder="Masukkan Detail Highlight"
                                                        onChange={handleChange}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 1</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_satu"
                                                        placeholder="Masukkan Title Foto 1"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Foto 1</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_satu"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.foto_satu && (
                                                        <div className="preview-container-blog">
                                                            <img
                                                                src={preview.foto_satu}
                                                                alt="Preview"
                                                                className="preview-image-blog"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Detail Foto 1</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="detail_foto_satu"
                                                        placeholder="Masukkan Detail Foto 1"
                                                        onChange={handleChange}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 2</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_dua"
                                                        placeholder="Masukkan Title Foto 2"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Foto 2</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_dua"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.foto_dua && (
                                                        <div className="preview-container-blog">
                                                            <img
                                                                src={preview.foto_dua}
                                                                alt="Preview"
                                                                className="preview-image-blog"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Detail Foto 2</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="detail_foto_dua"
                                                        placeholder="Masukkan Detail Foto 2"
                                                        onChange={handleChange}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 3</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_tiga"
                                                        placeholder="Masukkan Title Foto 3"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Foto 3</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_tiga"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.foto_tiga && (
                                                        <div className="preview-container-blog">
                                                            <img
                                                                src={preview.foto_tiga}
                                                                alt="Preview"
                                                                className="preview-image-blog"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Detail Foto 3</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="detail_foto_tiga"
                                                        placeholder="Masukkan Detail Foto 3"
                                                        onChange={handleChange}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/blog">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default BlogAdd;
